<h3>Event</h3>
<mat-card class="bo9mat">
  <form [formGroup]="EventForm"  class="personal-form">
    @if (event) {
      <div>Key: {{ event?._key }}</div>
    }

    @if (event) {
      <div>Attendees Count: {{ event.attendees}}</div>
    }
    @if (loading) {
      <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    }

    <mat-form-field  appearance="outline" >
      <mat-label>Event Name</mat-label>
      <input matInput
        formControlName="name"
        id="name" required
        />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select matNativeControl  formControlName="status" required>
        @for (reltype of statusList; track reltype) {
          <mat-option [value]="reltype">
            {{ reltype }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" >
      <mat-label>Categories</mat-label>
      <mat-select matNativeControl  formControlName="categories" required multiple>
        @for (reltype of catListDB; track reltype) {
          <mat-option [value]="reltype">
            {{ reltype }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field  appearance="outline">
      <mat-label>Start Date (yyyy-mm-dd)</mat-label>
      <input matInput
        formControlName="startDate"
        id="startDate" required
        (blur)="startSet($event)"
        />
    </mat-form-field>
    <mat-form-field  appearance="outline" >
      <mat-label>Start Time (24:00)</mat-label>
      <input matInput
        formControlName="startTime"
        id="startTime" required
        />
    </mat-form-field>
    <mat-form-field  appearance="outline">
      <mat-label>End Date (yyyy-mm-dd)</mat-label>
      <input matInput
        formControlName="endDate"
        id="endDate" required
        />
    </mat-form-field>
    <mat-form-field  appearance="outline" >
      <mat-label>Timezone</mat-label>
      <mat-select matNativeControl  formControlName="timezone">
        @for (reltype of timezones; track reltype) {
          <mat-option [value]="reltype">
            {{ reltype }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field  appearance="outline" >
      <mat-label>Event Link URL</mat-label>
      <input matInput
        formControlName="linkUrl"
        id="linkUrl"
        />
    </mat-form-field>
    <mat-form-field  appearance="outline" >
      <mat-label>Recording URL</mat-label>
      <button mat-button [cdkCopyToClipboard]="EventForm.value.recording_link"><mat-icon >content_copy</mat-icon></button>
      <input matInput
        formControlName="recording_link"
        id="recording_link"
        />
    </mat-form-field>

    @if (event?.recordingStartedAt) {
      <span>Recording Started: {{ event.recordingStartedAt }}</span>
      } @if (event?.recordingStartedAt) {
      <span>- Recording Ended At {{ event.recordingEndedAt }} </span>
      } <br />
      <button mat-button [disabled]="disableBtn" (click)="submitEventForm()" class="btn btn-save" mat-submit-button>Submit</button>
    </form>
  </mat-card>
  <mat-card class="bo9mat">
    @if (loading) {
      <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    }
    @if (event?._key) {
      <span>
        <form [formGroup]="RecordingForm"  (ngSubmit)="submitRecordingForm()" class="Pearl-form" novalidate >
          Recording File Upload (Max size 100MB):
          <mat-form-field>
            <ngx-mat-file-input2 [formControl]="fileControl" ></ngx-mat-file-input2>
          </mat-form-field> &nbsp;
          <button mat-button type="submit" [disabled]="disableBtn" class="btn btn-save mat-submit-button">Load File</button>
        </form>
      </span>
    } @else {
      <H3>The event must be created and saved before a file can be uploaded</H3>
    }

  </mat-card>
  <mat-card class="bo9mat">

    <form [formGroup]="URLForm"  class="personal-form">

      <mat-form-field  appearance="outline" >
        <mat-label>Recording filename</mat-label>
        <input matInput
          formControlName="url"
          id="url" required
          />
      </mat-form-field>
    </form>
    <button mat-button  [disabled]="disableBtn" (click)="submitURLForm()" class="btn btn-save" >RegenURL</button> <br />
    <button mat-button [cdkCopyToClipboard]="newFileName"><mat-icon >content_copy</mat-icon></button>

    <div class="longurl">URL: {{ newFileName }} </div></mat-card>